import { Injectable } from '@angular/core';
import { SignPhoneNumberAdjustment } from '../../../../model/sign/phone/sign-phone-number-adjustment';

@Injectable({
  providedIn: 'root'
})
export class SignPhoneNumberAdjustmentFactory {
  public createSignPhoneNumberAdjustment(): SignPhoneNumberAdjustment {
    const toReturn = new SignPhoneNumberAdjustment();
    toReturn.examples = [];

    return toReturn;
  }
}
